export const PagesStyle = {
    container: () => ({
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
        gap: 1.25,
        m: 'auto',
        p: 4,
        width: '100%',
        minHeight: '1px',
    }),
    inner: () => ({
        display: 'flex',
        flexFlow: 'column nowrap',
        flex: '1 0 auto',
        width: '100%',
        minHeight: '1px',
        maxWidth: '340px',
    }),
    section: () => ({
        display: 'flex',
        flexFlow: 'column nowrap',
        width: '100%',
        '&:not(:last-child)': {
            mb: {xs: 1.25, md: 2.5},
        },
    }),
    list: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
    },
    list_item: {
        display: 'inline-block',
        margin: 0,
        padding: 0,
    },
};
